import store from "../../redux/store";

/**
 * @param  {string} cookieName=''
 */

const getCookie = function getCookie(cookieName = store.getState().cookieName) {
    const cookies = document.cookie.split('; ');
    const cookie = cookies.find(e => (e.indexOf(`${cookieName}=`) >= 0));

    if (!!cookie) {
        return cookie.split('=')[1];
    }

    return null;
};

export default getCookie;